import React, { FC } from 'react'
import Button from 'Components/Shared/Button/Button'
import { BlockLayout, AddonData } from 'types'
import AddonGroup from '../AddonGroup/AddonGroup'
import StoreBanner from '../../../Shared/StoreBanner/StoreBanner'
import { AddonPageStyle } from './AddonPageStyle'

export interface AddonPageProps {
  data: AddonData[]
  layout: BlockLayout
  bannerName?: string
  bannerLogoSrc?: string
  introText?: string
  footerText?: string
  onContinue?: () => void
}

/**
 * AddonPage is used to display the list of add ons, the banner with store  logo and continue button as well.
 * ThemeProvider component is used. By using the theme object we provide same styling options to all components.
 */
const AddonPage: FC<AddonPageProps> = ({
  data,
  layout,
  bannerName,
  bannerLogoSrc,
  introText,
  footerText,
  onContinue,
}) => {
  return (
    <AddonPageStyle>
      <StoreBanner name={bannerName} logoSrc={bannerLogoSrc} />
      {introText && (
        <div
          className="introText"
          dangerouslySetInnerHTML={{ __html: introText }}
        />
      )}
      <AddonGroup data={data} layout={layout} />
      {footerText && (
        <div
          className="footerText"
          dangerouslySetInnerHTML={{ __html: footerText }}
        />
      )}
      {onContinue && <Button onClick={onContinue}>Continue</Button>}
    </AddonPageStyle>
  )
}

export default AddonPage
